// extracted by mini-css-extract-plugin
export default {"lessonStatusContainer":"LessonStatus_lessonStatusContainer__IORhn","imgContainer":"LessonStatus_imgContainer__ZIGRN","bottom":"LessonStatus_bottom__PZV7L"};